export const awareGoTheme = {
    primary: '#20A26B',
    secondary: '#AD2931',
};
